import { sequenceSaveStatus, sequenceStatusValues } from '../constants/simulator-constants';
import { ISequenceItem } from '../models';

type UsePulseSequenceSaveStatusProps = {
  item: ISequenceItem;
};

type UsePulseSequenceSaveStatusOutput = (typeof sequenceSaveStatus)[keyof typeof sequenceSaveStatus];

const runnablePulseSequenceStatuses = [sequenceStatusValues.runnable, sequenceStatusValues.none] as string[];

export const usePulseSequenceSaveStatus = ({
  item,
}: UsePulseSequenceSaveStatusProps): UsePulseSequenceSaveStatusOutput => {
  if (runnablePulseSequenceStatuses.includes(item.experimentStatus) && !item.points) {
    return sequenceSaveStatus.UNSAVED;
  }
  return sequenceSaveStatus.SAVED;
};
